import { Box, Card, Grid, GridItem, Spinner, Image, IconButton, CardFooter, Button } from '@chakra-ui/react';
import { MdAdd } from 'react-icons/md';
import { Dispatch, SetStateAction, useState } from 'react';
import moment from 'moment';

import GalleryModal from '@app/components/common/modals/gallery';
import { ImageDescriptor } from '@app/api/models';
import { useApi } from '@app/hooks';


export const ImagesField = ({ images, loading, setImages, readOnly = false }: {
  images: ImageDescriptor[];
  loading?: boolean;
  setImages: Dispatch<SetStateAction<ImageDescriptor[]>>
  readOnly?: boolean;
}) => {
  const api = useApi();
  const [uploading, setUploading] = useState<boolean>(false);
  const [removingImage, setRemovingImage] = useState<number>();
  const [showGallery, setShowGallery] = useState<boolean>(false);
  const [galleryCurrentIndex, setGalleryCurrentIndex] = useState<number>(0);

  const onAddClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();
    input.onchange = (e: Event) => {
      setUploading(true);
      const file = (e.target as HTMLInputElement).files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        setImages((images) => [
          ...images,
          {
            image_pid: null,
            last_update: moment().format('YYYY-MM-DD'),
            src: reader.result.toString(),
          },
        ]);
        setUploading(false);
      };
      reader.onerror = function (e) {
        console.log(e);
      };
    };
  };

  const onDeleteClick = async (imagePid: number) => {
    setRemovingImage(imagePid);
    await api.file.remove('' + imagePid);

    setImages((images) => images.filter((item) => item.image_pid !== imagePid));

    setRemovingImage(undefined);
  };

  return (<Grid 
    gap={5} 
    style={{ position: 'relative' }}
    templateColumns={{ base: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)', lg: 'repeat(6, 1fr)' }}
  >
    {loading && (
      <Box
        position="absolute"
        width="100%"
        height={200}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner />
      </Box>
    )}
    {images.map((image, index) => {
      return (
        <GridItem key={image.image_pid}>
          <Card position='relative'>
            {image.image_pid === removingImage && (
              <Box
                position="absolute"
                width="100%"
                height={200}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner />
              </Box>
            )}
            <Image
              style={{ height: '200px', cursor: 'pointer' }}
              src={image.src}
              objectFit='cover'
              onClick={() => {
                setGalleryCurrentIndex(index);
                setShowGallery(true);
              }}
            />
            <CardFooter>
              {!readOnly && <Button
                size="small"
                color="primary"
                onClick={() => onDeleteClick(image.image_pid)}
              >
                Удалить
              </Button>}
            </CardFooter>
          </Card>
        </GridItem>
      );
    })}
    {!readOnly && <GridItem style={{ opacity: loading ? '0.3' : 1 }}>
      <Box
        minHeight={200}
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        borderRadius={8}
        border="dotted 1px #AAA"
        position="relative"
      >
        {uploading && (
          <Box
            position="absolute"
            width="100%"
            height={200}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Spinner />
          </Box>
        )}
        {!uploading && (
          <IconButton color="primary" aria-label="add" onClick={onAddClick}>
            <MdAdd />
          </IconButton>
        )}
      </Box>
    </GridItem>}
    <GalleryModal
      images={images}
      open={showGallery}
      onClose={() => setShowGallery(false)}
      title="Изображения"
      index={galleryCurrentIndex}
      icon={<div />}
    />
  </Grid>);
};